import BillingContactNotificationChoices from 'components/billingContacts/BillingContactNotificationChoices';
import StyledInput from 'components/styledInput/StyledInput';
import UseContext from 'hooks/useContext';

/**
 * The fields of a billing contact without an account (mockups 8.5 and 8.6):
 * email, first name, last name, optional number, and the two boxes. Controlled
 * and without any request: `form` comes from billingContactForm.js, `errors`
 * holds texts ready to show ({ email, firstName, lastName, phone, position,
 * notifications }), and `onChange(field, value)` reports each edit.
 */
const BillingContactExternalForm = ({
  form,
  errors = {},
  onChange,
  isDisabled = false,
  // A contact of the company (ModalAddCompanyContact) receives nothing: no
  // boxes, but a position.
  withNotifications = true,
  withPosition = false,
}) => {
  const { language } = UseContext();
  const text = (key) =>
    language.getValue(`companyBillingContacts.external.${key}`, '');

  const fromEvent = (field) => (event) => onChange(field, event.target.value);

  return (
    <div className={'flex flex-col gap-4 text-sm'}>
      <StyledInput
        label={text('email')}
        type={'email'}
        value={form.email}
        onChange={fromEvent('email')}
        error={errors.email}
        isDisabled={isDisabled}
      />
      <div className={'grid grid-cols-2 gap-3'}>
        <StyledInput
          label={text('firstName')}
          type={'text'}
          value={form.firstName}
          onChange={fromEvent('firstName')}
          error={errors.firstName}
          isDisabled={isDisabled}
        />
        <StyledInput
          label={text('lastName')}
          type={'text'}
          value={form.lastName}
          onChange={fromEvent('lastName')}
          error={errors.lastName}
          isDisabled={isDisabled}
        />
      </div>
      <StyledInput
        label={text('phone')}
        type={'phone'}
        value={form.phone}
        onChange={(value) => onChange('phone', value)}
        error={errors.phone}
        isDisabled={isDisabled}
      />
      {withPosition && (
        <StyledInput
          label={text('position')}
          type={'text'}
          value={form.position ?? ''}
          onChange={fromEvent('position')}
          error={errors.position}
          isDisabled={isDisabled}
        />
      )}
      {withNotifications && (
        <BillingContactNotificationChoices
          invoices={form.invoices}
          reminders={form.reminders}
          onChange={onChange}
          isDisabled={isDisabled}
          error={errors.notifications}
        />
      )}
    </div>
  );
};

export default BillingContactExternalForm;
